import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import async from './modules/async'
import auth from './modules/auth'

const vuexLocal = new VuexPersistence({
  key: 'api4com-portal'
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  modules: {
    async,
    auth
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js